import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { Box } from "../../../../../assets/globalStyles/styledColoredBoxWithInfo";
import { Confirm } from "../../../../../components/confirm";
import {
  TEAM_LIST_HINT_FOR_COPY_BASIC_INFO,
  WARNING_SINGLE_BUTTON_TEXT
} from "../../../../../constants/otherTexts";
import { SelectTeams } from "../../../../../projectSpecificComponents/selectTeams";
import { StyledIcon } from "../../../../../assets/globalStyles/styledIcon";

const Index = props => {
  const {
    allAccessibleTeams,
    input: { value, onChange }
  } = props;
  const [confirm, setConfirm] = useState({ show: false, message: "" });
  const closeConfirm = () => {
    setConfirm({ show: false, message: "" });
  };
  const showConfirm = infoMessage => {
    setConfirm({ show: true, message: infoMessage });
  };

  return (
    <React.Fragment>
      <Confirm
        show={confirm.show}
        rejectHandler={() => closeConfirm()}
        close={() => closeConfirm()}
        content={{
          type: "info",
          message: confirm.message,
          rejectButtonText: WARNING_SINGLE_BUTTON_TEXT,
          icon: "icon mapsa-i-letter"
        }}
      />
      <Box>
        <div className="header-inner-container">
          <span className="title">وضعیت نمایش اطلاعات پایه</span>
          <StyledIcon
            onClick={() => showConfirm(TEAM_LIST_HINT_FOR_COPY_BASIC_INFO)}
            mr={8}
            fontSize={22}
          >
            <i className="icon mapsa-info" />
          </StyledIcon>
        </div>
        <SelectTeams
          allAccessibleTeams={allAccessibleTeams}
          selectedTeamIds={value}
          setSelectedTeamIds={onChange}
        />
      </Box>
    </React.Fragment>
  );
};

export default withRouter(Index);
